export default __webpack_public_path__ + "static/media/B227.e81cc6b0.png";